module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page wallet",
    staticStyle: {
      "background-color": "white",
      "min-height": "15rem"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('mu-appbar', {
    staticClass: "center"
  }, [_c('mu-icon', {
    staticStyle: {
      "margin-bottom": "-0.05rem"
    },
    attrs: {
      "slot": "left",
      "value": "keyboard_arrow_left",
      "color": "white"
    },
    on: {
      "click": _vm.goback
    },
    slot: "left"
  }), _vm._v(" "), _c('span', {
    staticClass: "topT left"
  }, [_vm._v("填写订单")])], 1)], 1), _vm._v(" "), (!_vm.loginState) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "padding": "14px",
      "color": "#FF9347",
      "font-size": "0.28rem",
      "background-color": "#fff3ea",
      "border-bottom": "1px solid #ffdac4",
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("登录后预订可享受更多优惠\n            "), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#FF9347",
      "position": "absolute",
      "right": "0.4rem",
      "top": "0.25rem"
    },
    on: {
      "click": _vm.gologin
    }
  }, [_vm._v("立即登录")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('h3', [_vm._v(_vm._s(_vm.g_currentInfo.HotelName))]), _vm._v(" "), _c('mu-divider')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden",
      "line-height": "1rem"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left",
      "margin-left": "0.3rem",
      "font-size": "0.30rem",
      "font-weight": "600",
      "color": "#333"
    }
  }, [_vm._v("\n            入住时间\n        ")]), _vm._v(" "), _c('mu-dropDown-menu', {
    staticStyle: {
      "float": "left",
      "margin-top": "0",
      "margin-bottom": "0",
      "margin-left": "0.3rem",
      "font-size": "0.3rem"
    },
    attrs: {
      "value": _vm.relaxHour,
      "icon": "search",
      "id": "LiveDate2"
    },
    on: {
      "change": _vm.setRelaxHour
    }
  }, _vm._l((_vm.HourList), function(item) {
    return _c('mu-menu-item', {
      attrs: {
        "value": item,
        "title": item + ':00'
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "1rem",
      "font-size": "0.28rem"
    }
  }, [_vm._v(_vm._s(_vm.arriveDateFormat) + " (" + _vm._s(_vm.relaxHourEND) + ":00离店)")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.1rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "greyBlock",
    staticStyle: {
      "margin-top": "-0.2rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main",
    staticStyle: {
      "min-height": "13rem"
    }
  }, [_c('div', {
    staticClass: "room"
  }, [_c('label', [_vm._v("房型名称")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.g_currentRoom.RoomTypeName))])]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticClass: "room"
  }, [_c('label', [_vm._v("入住人")]), _vm._v(" "), (_vm.loginState) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cusName),
      expression: "cusName"
    }],
    staticStyle: {
      "color": "#666",
      "border": "0",
      "outline": "0",
      "font-size": "0.28rem",
      "width": "3rem"
    },
    attrs: {
      "placeholder": "请输入姓名"
    },
    domProps: {
      "value": (_vm.cusName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cusName = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cusName),
      expression: "cusName"
    }],
    staticStyle: {
      "color": "#666",
      "border": "0",
      "outline": "0",
      "font-size": "0.28rem",
      "width": "3rem"
    },
    attrs: {
      "placeholder": "请输入姓名"
    },
    domProps: {
      "value": (_vm.cusName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cusName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticClass: "room"
  }, [_c('label', [_vm._v("手机")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNum),
      expression: "phoneNum"
    }],
    staticStyle: {
      "color": "#666",
      "border": "0",
      "outline": "0",
      "font-size": "0.28rem",
      "width": "3rem"
    },
    attrs: {
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phoneNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNum = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.loginState) ? _c('mu-divider') : _vm._e(), _vm._v(" "), (!_vm.loginState) ? _c('div', {
    staticClass: "room"
  }, [_c('label', [_vm._v("图像验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgCode),
      expression: "imgCode"
    }],
    staticStyle: {
      "color": "#666",
      "border": "0",
      "outline": "0",
      "font-size": "0.28rem",
      "width": "3rem"
    },
    attrs: {
      "placeholder": "请输入图像验证码"
    },
    domProps: {
      "value": (_vm.imgCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imgCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "1.5rem",
      "margin": "auto"
    },
    attrs: {
      "src": _vm.TPFJM,
      "align": "right"
    },
    on: {
      "click": _vm.getValidateCode
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.loginState) ? _c('mu-divider') : _vm._e(), _vm._v(" "), (!_vm.loginState) ? _c('div', {
    staticClass: "room"
  }, [_c('label', [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FJM),
      expression: "FJM"
    }],
    staticStyle: {
      "color": "#666",
      "border": "0",
      "outline": "0",
      "font-size": "0.28rem",
      "width": "3rem"
    },
    attrs: {
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.FJM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.FJM = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveYZM == false),
      expression: "haveYZM == false"
    }],
    staticStyle: {
      "padding": "0",
      "width": "1.5rem",
      "height": "35px",
      "text-align": "center",
      "display": "inline-block",
      "line-height": "35px",
      "margin": "auto",
      "color": "white",
      "background-color": "#27ba69"
    },
    on: {
      "click": _vm.noLoginValid
    }
  }, [_vm._v("获取")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveYZM == true),
      expression: "haveYZM == true"
    }],
    staticStyle: {
      "padding": "0",
      "width": "1.5rem",
      "height": "35px",
      "text-align": "center",
      "display": "inline-block",
      "line-height": "35px",
      "margin": "auto",
      "color": "#999",
      "background-color": "#eeeeee"
    }
  }, [_vm._v(_vm._s(_vm.WaitTime))])]) : _vm._e(), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticClass: "room"
  }, [_c('label', [_vm._v("特殊要求")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requires),
      expression: "requires"
    }],
    staticStyle: {
      "color": "#666",
      "border": "0",
      "outline": "0",
      "font-size": "0.28rem",
      "width": "4.5rem"
    },
    attrs: {
      "placeholder": "请输入您的特殊要求"
    },
    domProps: {
      "value": (_vm.requires)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.requires = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticClass: "room"
  }, [_c('label', [_vm._v("需要发票")]), _vm._v(" "), _c('mu-switch', {
    staticStyle: {
      "width": "80px",
      "margin": "auto 0px"
    },
    on: {
      "change": _vm.changeInvo
    },
    model: {
      value: (_vm.hasInvo),
      callback: function($$v) {
        _vm.hasInvo = $$v
      },
      expression: "hasInvo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "couponList"
  }, [(_vm.loginState) ? _c('p', [_c('label', [_vm._v("优惠券")])]) : _vm._e(), _vm._v(" "), (_vm.loginState) ? _c('div', {
    staticClass: "coupons"
  }, [(_vm.vochers != '' && _vm.vochers != null) ? _c('div', {
    staticClass: "coupon",
    class: {
      active: _vm.useState.useVocher
    },
    staticStyle: {
      "width": "136px"
    },
    on: {
      "click": function($event) {
        return _vm.focus(1)
      }
    }
  }, [_c('div', [_c('h3', [_vm._v("代金券")]), _vm._v(" "), (_vm.voState) ? _c('mu-dropDown-menu', {
    staticStyle: {
      "float": "left",
      "margin-top": "0",
      "margin-bottom": "0",
      "margin-left": "0.1rem",
      "font-size": "0.25rem"
    },
    attrs: {
      "value": _vm.vocher,
      "icon": "search",
      "id": "LiveDate3",
      "labelClass": "vocherList",
      "autoWidth": true
    },
    on: {
      "change": _vm.changeVocher
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "value": "0",
      "title": "不抵扣"
    }
  }), _vm._v(" "), _vm._l((_vm.vochers), function(voc) {
    return (_vm.userVochers['v' + voc] != '') ? _c('mu-menu-item', {
      attrs: {
        "value": voc,
        "title": '抵' + voc + '小时'
      }
    }) : _vm._e()
  })], 2) : _vm._e()], 1)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.g_currentRoom.RoomType == 102 || _vm.g_currentRoom.RoomType == 103) ? _c('div', {
    staticStyle: {
      "margin-left": "0.3rem"
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.g_currentRoom.ActivityComment))])]) : _vm._e(), _vm._v(" "), (_vm.hasInvo) ? _c('mu-list-item', {
    staticStyle: {
      "width": "90%",
      "padding": "0px",
      "background-color": "#FCFCFC",
      "margin": "0 auto",
      "margin-bottom": "15px"
    },
    attrs: {
      "title": _vm.invoiceInfo.InvoiceType + ' ' + _vm.invoiceInfo.InvoiceProperty + ' ' + _vm.invoiceInfo.Name,
      "titleClass": "invoice"
    },
    on: {
      "click": function($event) {
        return _vm.changeInvo(true)
      }
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "check"
  }, [_c('label', [_vm._v("订单金额：")]), _vm._v(" \n            "), (!_vm.loginState) ? _c('span', {
    staticClass: "money"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm._f("fomatFloat")(_vm.g_currentRoom.NotMemberPrice)) + " 元\n            ")]) : _vm._e(), _vm._v(" "), (_vm.loginState) ? _c('span', {
    staticClass: "money"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm._f("fomatFloat")(_vm.g_currentRoom.MemberPrice)) + " 元\n            ")]) : _vm._e(), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.SubmitRelaxHotelOrder
    }
  }, [_c('span', {
    staticStyle: {}
  }, [_vm._v("提交订单")])])])], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.invoice,
      "dialogClass": "invoiceDia"
    }
  }, [_c('mu-tabs', {
    staticClass: "invoiceTab",
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "tab1",
      "title": "增值税普通发票"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab2",
      "title": "增值税专用发票"
    }
  })], 1), _vm._v(" "), (_vm.activeTab === 'tab1') ? _c('div', {
    staticStyle: {
      "padding": "1em 0",
      "text-align": "center"
    }
  }, [_c('mu-radio', {
    staticClass: "invoice-radio",
    attrs: {
      "label": "个人发票",
      "name": "normal",
      "nativeValue": "person"
    },
    on: {
      "click": function($event) {
        return _vm.setInvoiceInfo('tab1', 'person')
      }
    },
    model: {
      value: (_vm.normalType),
      callback: function($$v) {
        _vm.normalType = $$v
      },
      expression: "normalType"
    }
  }), _vm._v(" "), _c('mu-radio', {
    staticClass: "invoice-radio",
    attrs: {
      "label": "公司发票",
      "name": "normal",
      "nativeValue": "company"
    },
    on: {
      "click": function($event) {
        return _vm.setInvoiceInfo('tab1', 'company')
      }
    },
    model: {
      value: (_vm.normalType),
      callback: function($$v) {
        _vm.normalType = $$v
      },
      expression: "normalType"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "15px",
      "margin-bottom": "2rem"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "label": "抬头",
      "hintText": "请填写发票抬头"
    },
    model: {
      value: (_vm.invoiceInfo.Name),
      callback: function($$v) {
        _vm.$set(_vm.invoiceInfo, "Name", $$v)
      },
      expression: "invoiceInfo.Name"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.normalType == "company") ? _c('mu-text-field', {
    attrs: {
      "label": "税号",
      "hintText": "请填写税号"
    },
    model: {
      value: (_vm.invoiceInfo.IndentityNo),
      callback: function($$v) {
        _vm.$set(_vm.invoiceInfo, "IndentityNo", $$v)
      },
      expression: "invoiceInfo.IndentityNo"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.normalType == "person") ? _c('label', {
    staticStyle: {
      "color": "#999999",
      "font-size": "0.22rem"
    }
  }, [_vm._v("*个人普通发票仅需填写抬头")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.normalType == "company") ? _c('label', {
    staticStyle: {
      "color": "#999999",
      "font-size": "0.22rem"
    }
  }, [_vm._v("*公司普通发票需填写抬头和税号")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'tab2') ? _c('div', {
    staticStyle: {
      "padding": "1em 15px",
      "overflow-y": "scroll",
      "max-height": "9rem",
      "overflow-x": "hidden"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "label": "抬头",
      "hintText": "请填写发票抬头"
    },
    model: {
      value: (_vm.invoiceInfo.Name),
      callback: function($$v) {
        _vm.$set(_vm.invoiceInfo, "Name", $$v)
      },
      expression: "invoiceInfo.Name"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "税号",
      "hintText": "请填写税号"
    },
    model: {
      value: (_vm.invoiceInfo.IndentityNo),
      callback: function($$v) {
        _vm.$set(_vm.invoiceInfo, "IndentityNo", $$v)
      },
      expression: "invoiceInfo.IndentityNo"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "电话",
      "hintText": "请填写电话"
    },
    model: {
      value: (_vm.invoiceInfo.Phone),
      callback: function($$v) {
        _vm.$set(_vm.invoiceInfo, "Phone", $$v)
      },
      expression: "invoiceInfo.Phone"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "地址",
      "hintText": "请填写地址"
    },
    model: {
      value: (_vm.invoiceInfo.Address),
      callback: function($$v) {
        _vm.$set(_vm.invoiceInfo, "Address", $$v)
      },
      expression: "invoiceInfo.Address"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "开户行",
      "hintText": "请填写开户行"
    },
    model: {
      value: (_vm.invoiceInfo.BankName),
      callback: function($$v) {
        _vm.$set(_vm.invoiceInfo, "BankName", $$v)
      },
      expression: "invoiceInfo.BankName"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "账号",
      "hintText": "请填写账号"
    },
    model: {
      value: (_vm.invoiceInfo.BankAccountNo),
      callback: function($$v) {
        _vm.$set(_vm.invoiceInfo, "BankAccountNo", $$v)
      },
      expression: "invoiceInfo.BankAccountNo"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#999999",
      "font-size": "0.22rem"
    }
  }, [_vm._v("*填写增值税专用发票请务必保证信息正确完整")]), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "invoice-button",
    attrs: {
      "slot": "actions",
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": _vm.saveInvoice
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "invoice-button",
    attrs: {
      "slot": "actions",
      "label": "取消"
    },
    on: {
      "click": _vm.closeInvoice
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "room"
  }, [_c('label', [_vm._v("房间数")]), _vm._v(" "), _c('span', [_vm._v("\n                    1 间\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("活动说明")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-793a5bae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/makeOrderToRelax.vue
// module id = 1554
// module chunks = 18